import { render, staticRenderFns } from "./MailTemplateCreateDialog.vue?vue&type=template&id=5f1bf901&scoped=true"
import script from "./MailTemplateCreateDialog.vue?vue&type=script&lang=ts"
export * from "./MailTemplateCreateDialog.vue?vue&type=script&lang=ts"
import style0 from "./MailTemplateCreateDialog.vue?vue&type=style&index=0&id=5f1bf901&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1bf901",
  null
  
)

export default component.exports